export const training = {
  en: [
    {
      id: 1,
      name: "Al-Fath Skill Academy - QA Automation",
      organizer: "Al-Fath FIF Telkom University",
      participant: "Informatics Faculty Students of Telkom University",
      description: [
        "An offline training program focused on QA Automation using Katalon Studio, covering test case creation, execution, and reporting.",
        "The training program lasted 6 sessions, from October to December 2025, with a total duration of 12 hours.",
        "The material covered includes: Introduction to Software Testing, Fundamental QA, Test Case and Bug Reporting, Functional and API Testing using Katalon Studio, and Preparation of Test Result Reports.",
      ],
      date: "Oktober - Desember 2025",
      img: require("@/assets/images/training/alfath2025.jpg"),
      link: "/files/Certificate-BootcampASA.pdf",
    },
    {
      id: 2,
      name: "QA Automation with Katalon Studio - Training",
      organizer: "GlobalEdu",
      participant: "IT Team of BCA Finance",
      description: [
        "Corporate training program for a leasing company focused on QA Automation using Katalon Studio.",
        "The material taught focuses on the QA Automation process using Katalon Studio, covering the basics of test automation, implementation of advanced Katalon features, reporting, and CI/CD integration.",
        "Through this training, participants are expected to understand the basic concepts of QA Automation, master the use of Katalon Studio for functional and API testing, and be able to produce effective test result reports.",
      ],
      date: "4 - 6 Februari 2026",
      img: require("@/assets/images/training/globaledufeb26.jpg"),
    },
    {
      id: 3,
      name: "Practical Methodology for Software Quality - Training",
      organizer: "GlobalEdu",
      participant: "QA Staff of Bank Resona Perdania",
      description: [
         "Corporate training program for a financing company focused on software quality and development methodology, covering the basics of software quality, the implementation of good development methodologies, and product quality reporting and evaluation.",
        "The material taught includes: Fundamental QA and Software Testing introduction, implementation of Software Testing in the Software Development Life Cycle (SDLC), simulation of software testing practices (including Test Case, Bug Reporting, and Test Report), and steps to improve software quality.",
        "Over the course of 3 days, participants will gain in-depth understanding of best practices in QA and QC, as well as how to implement effective testing strategies to ensure optimal software quality.",
      ],
      date: "23 - 25 Februari 2026",
      img: require("@/assets/images/training/globaledufeb26-2.jpg"),
    },
    {
      id: 4,
      name: "Software Quality Assurance & Quality Control - Training",
      organizer: "NQA Indonesia",
      participant: "IT Team of PT BPR DP TASPEN",
      description: [
        "Training program for a pension financing company focused on software quality and development methodology, covering the fundamentals of software quality, the implementation of good development methodologies, and product quality reporting and evaluation.",
        "Over the course of 3 days, participants will gain in-depth understanding of best practices in QA and QC, as well as how to implement effective testing strategies to ensure optimal software quality.",
        "The material taught includes: Fundamental QA and Software Testing introduction, implementation of Software Testing in the Software Development Life Cycle (SDLC), simulation of software testing practices (including Test Case, Bug Reporting, and Test Report), as well as steps to improve software quality.",
      ],
      date: "26 - 28 Agustus 2026",
      img: require("@/assets/images/training/nqaags26.jpeg"),
    },
    {
      id: 5,
      name: "Practical Learning Assesment for Software Quality Assurance - Training",
      organizer: "GlobalEdu",
      participant: "Pusat Data dan Informasi Obat dan Makanan (Pusdatin) - Badan Pengawasan Obat dan Makanan (BPOM)",
      description: [
        "Training program for a government institution focused on software quality and development methodology, covering the fundamentals of software quality, the implementation of good development methodologies, and product quality reporting and evaluation.",
        "Over the course of 3 days, participants will gain in-depth understanding of best practices in QA and QC, as well as how to implement effective testing strategies to ensure optimal software quality.",
        "The material taught includes: Fundamental QA and Software Testing introduction, implementation of Software Testing in the Software Development Life Cycle (SDLC), simulation of software testing practices (including Test Case, Bug Reporting, and Test Report), as well as steps to improve software quality.",
      ],
      date: "12 - 14 Oktober 2026",
      img: require("@/assets/images/training/globaleduokt26.jpg"),

    }
  ],
  id: [
    {
      id: 1,
      name: "Al-Fath Skill Academy - QA Automation",
      organizer: "Al-Fath FIF Telkom University",
      participant: "Mahasiswa Fakultas Informatika Telkom University",
      description: [
        "Program pelatihan offline yang berfokus pada QA Automation menggunakan Katalon Studio, mencakup pembuatan, eksekusi, dan pelaporan test case.",
        "Program pelatihan berlangsung selama 6 pertemuan, dimulai dari Oktober hingga Desember 2025, dengan total durasi pelatihan sebanyak 12 jam.",
        "Materi yang diberikan meliputi: Pengenalan Software Testing, Fundamental QA, Pembuatan Test Case dan Bug Reporting, Pengujian Fungsional dan API menggunakan Katalon Studio, serta Pembuatan Laporan Hasil Pengujian.",
      ],
      date: "Oktober - Desember 2025",
      img: require("@/assets/images/training/alfath2025.jpg"),
      link: "/files/Certificate-BootcampASA.pdf",
    },
    {
      id: 2,
      name: "QA Automation with Katalon Studio - Training",
      organizer: "GlobalEdu",
      participant: "IT Team BCA Finance",
      description: [
        "Program training korporasi untuk perusahaan leasing yang berfokus pada QA Automation menggunakan Katalon Studio",
        "Materi yang diajarkan berfokus pada proses QA Automation menggunakan Katalon Studio, mencakup dasar-dasar otomasi pengujian, penerapan fitur-fitur advanced Katalon, Reporting dan integrasi CI/CD.",
        "Melalui pelatihan ini, peserta diharapkan dapat memahami konsep dasar QA Automation, menguasai penggunaan Katalon Studio untuk pengujian fungsional dan API, serta mampu membuat laporan hasil pengujian yang efektif.",
      ],
      date: "4 - 6 Februari 2026",
      img: require("@/assets/images/training/globaledufeb26.jpg"),
    },
    {
      id: 3,
      name: "Practical Methodology for Software Quality - Training",
      organizer: "GlobalEdu",
      participant: "QA Staff Bank Resona Perdania",
      description: [
        "Program training korporasi untuk perusahaan pembiayaan yang berfokus pada kualitas perangkat lunak dan metodologi pengembangan, mencakup dasar-dasar kualitas perangkat lunak, penerapan metodologi pengembangan yang baik, serta pelaporan dan evaluasi kualitas produk.",
        "Materi yang diajarkan meliputi: Pengenalan fundamental QA dan Software Testing, penerapan Software Testing dalam Software Development Life Cycle (SDLC), simulasi penerapan pengujian perangkat lunak (meliputi Test Case, Bug Reporting, dan Test Report), serta langkah-langkah untuk meningkatkan kualitas perangkat lunak",
        "Selama 3 hari, peserta akan mendapatkan pemahaman mendalam tentang praktik terbaik dalam QA dan QC, serta bagaimana mengimplementasikan strategi pengujian yang efektif untuk memastikan kualitas perangkat lunak yang optimal.",
      ],
      date: "23 - 25 Februari 2026",
      img: require("@/assets/images/training/globaledufeb26-2.jpg"),
    },
    {
      id: 4,
      name: "Software Quality Assurance & Quality Control - Training",
      organizer: "NQA Indonesia",
      participant: "Tim IT - PT BPR DP TASPEN",
      description: [
        "Program training untuk perusahaan pembiayaan dana pensiun yang berfokus pada kualitas perangkat lunak dan metodologi pengembangan, mencakup dasar-dasar kualitas perangkat lunak, penerapan metodologi pengembangan yang baik, serta pelaporan dan evaluasi kualitas produk.",
        "Selama 3 hari, peserta akan mendapatkan pemahaman mendalam tentang praktik terbaik dalam QA dan QC, serta bagaimana mengimplementasikan strategi pengujian yang efektif untuk memastikan kualitas perangkat lunak yang optimal.",
        "Materi yang diajarkan meliputi: Pengenalan fundamental QA dan Software Testing, penerapan Software Testing dalam Software Development Life Cycle (SDLC), simulasi penerapan pengujian perangkat lunak (meliputi Test Case, Bug Reporting, dan Test Report), serta langkah-langkah untuk meningkatkan kualitas perangkat lunak", 
      ],
      date: "26 - 28 Agustus 2026",
      img: require("@/assets/images/training/nqaags26.jpeg"),
    },
    {
      id: 5,
      name: "Practical Learning Assesment for Software Quality Assurance - Training",
      organizer: "GlobalEdu",
      participant: "Pusat Data dan Informasi Obat dan Makanan (Pusdatin) - Badan Pengawasan Obat dan Makanan (BPOM)",
      description: [
        "Program training untuk instansi pemerintah yang berfokus pada kualitas perangkat lunak dan metodologi pengembangan, mencakup dasar-dasar kualitas perangkat lunak, penerapan metodologi pengembangan yang baik, serta pelaporan dan evaluasi kualitas produk.",
        "Materi yang diajarkan meliputi: Pengenalan fundamental QA dan Software Testing, penerapan Software Testing dalam Software Development Life Cycle (SDLC), simulasi penerapan pengujian perangkat lunak (meliputi Test Case, Bug Reporting, dan Test Report), serta langkah-langkah untuk meningkatkan kualitas perangkat lunak",
        "Selama 3 hari, peserta akan mendapatkan pemahaman mendalam tentang praktik terbaik dalam QA dan QC, serta bagaimana mengimplementasikan strategi pengujian yang efektif untuk memastikan kualitas perangkat lunak yang optimal.",
      ],
      date: "12 - 14 Oktober 2026",
      img: require("@/assets/images/training/globaleduokt26.jpg"),
    },
  ],
};
